import { ApolloLink } from '@apollo/client';

import { WITH_TIMER } from '../../../config';
import { generateAuthLink } from './authLink';
import type { GenerateErrorLinkArgs } from './errorLink';
import { generateErrorLink } from './errorLink';
import { generateHttpLink } from './httpLink';
import { timeLink } from './timeLink';

const IS_DEV = process.env.NODE_ENV === 'development';

export type GenerateSemiologicLinkArgs = GenerateErrorLinkArgs & {
  graphUrl?: string;
  // Appartenance produit (B0_02b) : produit émetteur, transmis à generateAuthLink. Paramétré par app.
  product?: string;
};

export const generateSemiologicLink = ({
  getToken,
  getPublicKey,
  graphUrl,
  triggerRefreshToken,
  logout,
  product,
}: GenerateSemiologicLinkArgs) =>
  ApolloLink.from(
    [
      IS_DEV && WITH_TIMER ? timeLink : null,
      generateErrorLink({ getToken, getPublicKey, triggerRefreshToken, logout }),
      generateAuthLink({
        getToken,
        getPublicKey,
        triggerRefreshToken,
        product,
      }),
      generateHttpLink(graphUrl),
    ].filter((elt): elt is ApolloLink => !!elt),
  );
